
import { ModalDetalheCooperadoProvider } from "../ModalDetalheCooperadoProvider";
import Listagem, { ListagemPublicosProps } from "./Listagem";

export default function ListarTodas({
    tipo_publico
}: ListarTodasProps) {
    return (
        <>
            <ModalDetalheCooperadoProvider>
                <Listagem {...{ tipo_publico }} />
            </ModalDetalheCooperadoProvider>
        </>
    )
}

interface ListarTodasProps extends ListagemPublicosProps { }